import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';

export interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TermsModal({ isOpen, onClose }: TermsModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent p="24px" maxWidth={'356px'}>
        <ModalHeader p="0" fontWeight="700" fontSize="14px" color="#667085">
          Termos e condições
        </ModalHeader>
        <ModalCloseButton top="20px" right="16px" />
        <ModalBody p="0" mt="24px">
          <Text fontWeight="400" fontSize="14px" color="#667085">
            Ao usar referido programa o usuário está ciente de que a Gerdau disponibiliza a
            ferramenta de cálculo sem qualquer custo e para apoiar a simulação do quantitativo e
            possíveis materiais a serem adquiridos pelo cliente. Aproveitamos a oportunidade para
            alertar que os valores apresentados pelo aplicativo são meras referências e os produtos
            propostos são meramente sugestivos, cabendo a decisão e correta aplicação do(s)
            material(is), quantidade(s), legislação, normas técnicas, quaisquer regulamentos e
            códigos de obra aplicáveis adequados à segurança e melhor aproveitamento do
            empreendimento exclusivamente ao profissional responsável técnico pela obra, não tendo a
            Gerdau qualquer responsabilidade sobre o projeto e eventuais implicações.
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
